var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-nav-desktop-sub-menu text-left"},[_c('NavTitle',[_vm._v(_vm._s(_vm.subNavData.title))]),_c('ul',{attrs:{"role":"menu"}},_vm._l((_vm.navItems),function(item,index){return _c('li',{key:index,staticClass:"sub-menu-item",attrs:{"role":"none"}},[_c('SiteNavSubMenuItem',{attrs:{"item":item,"hide-sub-title":true}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }